import React, { useEffect, useState, lazy } from 'react';
import { Provider, useDispatch, useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { ConfigProvider, Spin } from 'antd';
import store from './redux/store';
import Admin from './routes/admin';
import Panel from './routes/panel';
import Auth from './routes/auth';
import './static/css/style.css';
import './static/css/apps-components.css';
import config from './config/config';
import ProtectedRoute from './components/utilities/protectedRoute';
import 'antd/dist/antd.less';
import { loggedCheck } from './redux/authentication/actionCreator';
import SugesterChat from './components/sugesterChat';
import plPL from 'antd/lib/locale/pl_PL';

const InternalConfirmationPage = lazy(() => import('./container/domains/transfer/InternalConfirmationPage'));

const NotFound = lazy(() => import('./container/pages/404'));

const { theme } = config;

function ProviderConfig() {
  const dispatch = useDispatch();
  const { rtl, isLoggedIn, topMenu, mainContent, initialize } = useSelector((state) => {
    return {
      rtl: state.ChangeLayoutMode.rtlData,
      topMenu: state.ChangeLayoutMode.topMenu,
      mainContent: state.ChangeLayoutMode.mode,
      isLoggedIn: state.auth.isLoggedIn,
      initialize: state.auth.initialize,
    };
  });

  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    dispatch(loggedCheck());
  }, [dispatch]);

  useEffect(() => {
    let unmounted = false;
    if (!unmounted) {
      setPath(window.location.pathname);
    }
    // eslint-disable-next-line no-return-assign
    return () => (unmounted = true);
  }, [setPath]);

  if (!initialize)
    return (
      <div className="spin flex items-center justify-center bg-white dark:bg-dark h-screen w-full fixed z-[999] ltr:left-0 rtl:right-0 top-0">
        <Spin />
      </div>
    );

  return (
    <ConfigProvider locale={plPL} direction={rtl ? 'rtl' : 'ltr'}>
      <ThemeProvider theme={{ ...theme, rtl, topMenu, mainContent }}>
        <Router basename={process.env.PUBLIC_URL}>
          {!isLoggedIn ? (
            <Routes>
              <Route path="domain-transfer/confirm/:uuid" element={<InternalConfirmationPage />} />
              <Route path="/*" element={<Auth />} />
            </Routes>
          ) : (
            <Routes>
              <Route path="domain-transfer/confirm/:uuid" element={<InternalConfirmationPage />} />
              <Route path="/admin/*" element={<ProtectedRoute path="/*" Component={Admin} />} />
              <Route path="/*" element={<ProtectedRoute path="/*" Component={Panel} />} />
              <Route path="*" element={<NotFound />} />
              <Route exact path="/" element={<Navigate to="/domains" />} />
            </Routes>
          )}
          {isLoggedIn && (path === process.env.PUBLIC_URL || path === `${process.env.PUBLIC_URL}/`) && (
            <Routes>
              <Route path="/" element={<Navigate to="/domains" />} />
            </Routes>
          )}
        </Router>
        {isLoggedIn && <SugesterChat scriptSrc={process.env.REACT_APP_SUGGESTER_CHAT_WIDGET_URL} />}
      </ThemeProvider>
    </ConfigProvider>
  );
}

function App() {
  return (
    <Provider store={store}>
      <ProviderConfig />
    </Provider>
  );
}

export default App;
